// iter637/iter675 — Tooltip metadata for all 18 digital twins (incl. BHI)
// Used by UnifiedHealthTwinCard to display rich tooltips on each tile.
export const TWIN_TOOLTIPS = {
  nutritional: {
    title: "Хранителен близнак",
    description: "Следи дневния инсулиногенен бюджет (DIL), стабилност на кр. захар и хранителни модели. Обновява се при записване на хранене.",
    measures: "DIL · ястия днес · въглехидрати · фибри",
  },
  cognitive: {
    title: "Когнитивен близнак",
    description: "Концентрация и работна памет чрез N-back/Stroop тестове. Реал-тайм адаптация при гладуване.",
    measures: "7-дн avg · брой сесии · реакция в ms",
  },
  lab: {
    title: "Лабораторен близнак",
    description: "HbA1c, ЛДЛ, ХДЛ, hsCRP, витамини, ApoB и др. Поддържа PDF импорт с Vision OCR.",
    measures: "HbA1c · LDL/HDL · CRP · Vit D · TG",
  },
  phenotype: {
    title: "Метаболитен фенотип",
    description: "Класификация на 4 фенотипа: инсулин-резистентен, балансиран, въглехидрат-метаболизиращ, мазнини-метаболизиращ.",
    measures: "OGTT response · хранителни маркери",
  },
  microbiome: {
    title: "Микробиом",
    description: "Растително разнообразие (American Gut Project — цел 30/седмично) + ферментирали храни.",
    measures: "уникални растения · ферментирали порции",
  },
  body_comp: {
    title: "Телесен състав",
    description: "BMI, телесни мазнини %, обиколка талия. Корелира с метаболитен и кардио риск.",
    measures: "тегло · BF% · талия · мускулна маса",
  },
  sleep: {
    title: "Сън",
    description: "Продължителност, REM/deep, латентност на заспиване, пробуждания. Влияе на когнитивен и хормонален.",
    measures: "продължителност · REM/deep · latency",
  },
  stress: {
    title: "Стрес (кортизол)",
    description: "Кортизолова крива чрез храненето и slot-on-the-clock. Засяга щитовидна, имунна, гут.",
    measures: "DLI кортизол-натоварване · пико сутрин",
  },
  thyroid: {
    title: "Щитовидна",
    description: "TSH, FT4, FT3, anti-TPO/TG. Свързана с метаболитен, когнитивен, хормонален.",
    measures: "TSH · FT4 · FT3 · anti-TPO",
  },
  cardio: {
    title: "Кардиоваскуларен",
    description: "BP, пулс в покой, HRV, LDL/HDL ratio. ASCVD 10-year риск proxy.",
    measures: "BP · resting HR · HRV · LDL/HDL",
  },
  hormonal: {
    title: "Хормонално-репродуктивен",
    description: "Менструален цикъл, фази, перименопауза/менопауза (STRAW+10), MRS симптоми.",
    measures: "цикъл · фаза · симптоми · stage",
  },
  metabolic_insulin: {
    title: "Метаболитно-инсулинов",
    description: "HOMA-IR, TG/HDL ratio, ApoB/ApoA1. Ранен индикатор за инсулинова резистентност.",
    measures: "HOMA-IR · TG/HDL · ApoB",
  },
  inflammation: {
    title: "Възпалителен",
    description: "Системно възпаление чрез hsCRP, neutrophil/lymphocyte ratio + противовъзпалителна диета.",
    measures: "hsCRP · NLR · омега-3 храни",
  },
  movement: {
    title: "Двигателен",
    description: "Стъпки, активни минути (WHO ≥150 мин/седм.), VO2 max, заседнало време.",
    measures: "стъпки · активни мин · VO2 · sit time",
  },
  mental_emotional: {
    title: "Психо-емоционален",
    description: "Mood, енергия, PHQ-9 (депресия), GAD-7 (тревожност). 15-сек дневни check-ins.",
    measures: "mood 7д · PHQ-9 · GAD-7",
  },
  liver_kidney: {
    title: "Чернодробно-бъбречен",
    description: "ALT, AST, GGT, eGFR, креатинин + употреба на алкохол. Проверка за омазняване на черния дроб.",
    measures: "ALT · GGT · eGFR · alcohol/седм.",
  },
  // iter637 — Dental Twin (17-ти)
  dental: {
    title: "Дентален",
    description: "Устна кухина, перио-риск, парафункции (бруксизъм), зъбна емайл/реминерализация. Свързан с кардио, метаболизъм, възпаление, чревен микробиом, хормони.",
    measures: "Tooth Protection · DHI scan · бруксизъм",
  },
  // iter675 / iter687 — Breast Health Intelligence (18-ти, gender-aware)
  bhi: {
    title: "Breast Health Intelligence",
    description: "Биология на гърдата за двата пола. ♀ Жени: естрогенен метаболизъм, инсулин/IGF-1, плътност, ECM. ♂ Мъже: < 1% от случаите но агресивен — следи BRCA2, гинекомастия, хормонален дисбаланс. Свързан с метаболитен, хормонален, лабораторен и възпалителен близнаци.",
    measures: "BDI · density · estrogen · ECM · BRCA2",
  },
};
